import { Col } from "antd";

export default function ColOpcion({ children, style }) {
  return (
    <Col xs={6} md={3} style={style}>
      {children}
    </Col>
  );
}
